<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else>
            <i class="far fa-id-card m-r-sm"></i> {{ accountUser.profile.full_name }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { RESET_ACCOUNT_USER } from 'vx/mutations'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: {
      ...mapState('user/accountUsers', ['accountUser'])
    },

    methods: {
      ...mapMutations('user/accountUsers', [RESET_ACCOUNT_USER])
    }
  }
</script>



// WEBPACK FOOTER //
// DriverHeading.vue?44657a98